import React from 'react';
import PropTypes from 'prop-types';
import './Sticker.css';

export const StickerVariants = {
    LIGHT_BEIGE: "light-beige",
    LIGHT_BLUE: "light-blue",
    LIGHT_CYAN: "light-cyan",
    LIGHT_GRAY: "light-gray",
    LIGHT_GREEN: "light-green",
    LIGHT_LIME: "light-lime",
    LIGHT_ORANGE: "light-orange",
    LIGHT_PINK: "light-pink",
    LIGHT_PURPLE: "light-purple",
    LIGHT_RED: "light-red",
    LIGHT_YELLOW: "light-yellow",
    GRAY: "gray",
    WHITE: "white",
}

const Sticker = (props) => {
    const { variant, className } = props;
    const bg = variant ? `sticker sticker-bg-${variant}` : "sticker";

    return (
        <span className={`${bg} ${className}`}>{props.children}</span>
    );
}

Sticker.defaultProps = {
    variant: "white",
}

Sticker.propTypes = {
    variant: PropTypes.string,
    className: PropTypes.string,
}

export default Sticker;